<template>
    <div class="container">
        <p class="f18 pb20">主账号信息</p>
        <el-row>
            <el-col :span="8">
                账号类型：
                <span v-if="detail.type==1">学校</span>
                <span v-if="detail.type==2">公司</span>
                <span v-if="detail.type==3">加盟</span>
            </el-col>
            <el-col :span="8">账号名称：{{detail.true_name}}</el-col>
            <el-col :span="8">
                登录账号：{{detail.mp}}
            </el-col>

        </el-row>
        <div class="line pt10"></div>
        <p class="f18 pb20">子账号管理</p>
        <el-row class="pb10">
            <el-button type="primary" size="mini" @click="addChild()">新增</el-button>
        </el-row>
        <!--table-->
        <el-table
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="id"
                    label="序号"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="account"
                    label="登录手机号"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="true_name"
                    label="用户名"
                    :show-overflow-tooltip="true"
                    width="200">
            </el-table-column>
            <el-table-column
                    prop="created_at"
                    label="创建时间"
                    width="">
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="addAuth(scope.row)">授权</el-button>
                    <el-button type="text" size="mini" @click="resetPwd(scope.row)">重置密码</el-button>
                    <el-button type="text" size="mini" @click="delChild(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="新增子账号" :visible.sync="dialogFormVisible" width="30%">
            <el-form size="mini" :model="form" :rules="rules" label-width="80px" ref="form">
                <el-form-item label="手机号" prop="child_account">
                    <el-input type="text" v-model="form.child_account" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="用户名" prop="child_name">
                    <el-input type="text" v-model="form.child_name" maxlength="15"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" size="mini" @click="submitForm('form')">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="子账号授权" :visible.sync="dialogFormVisible1" width="50%">
            <el-tree
                v-if="account_type == 4"
                :data="menus"
                show-checkbox
                default-expand-all
                node-key="district_id"
                ref="tree"
                highlight-current
                :props="defaultProps2">
            </el-tree>
            <el-tree
                v-else
                :data="menus"
                show-checkbox
                default-expand-all
                node-key="rule_id"
                ref="tree"
                highlight-current
                :props="defaultProps">
            </el-tree>
            <el-button type="primary" size="mini" @click="submitAuth()" style="margin-left: 50px">保存</el-button>
        </el-dialog>
    </div>
</template>

<script>
    import store from "../../store";

    export default {
        computed: {

        },
        data() {
            let checkMobile = (rule, value, callback) => {
              if (!value) {
                return callback(new Error('请输入手机号'));
              }
              let reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
              if (!reg.test(value)) {
                callback(new Error('请输入正确格式的手机号'));
              }
              callback();
            };
            return{
                account_type: null,
                detail: {},
                dialogFormVisible: false,
                dialogFormVisible1: false,
                form: {//查询表单数据
                    child_account: '',
                    child_name: '',
                    // commercial_id: this.detail.commercial_id,
                    // operator: this.detail.true_name
                },
                rules: {
                    child_account: [
                        { validator: checkMobile, trigger: 'blur' },
                        {required: true, message: '请输入手机号', trigger: 'blur'}
                    ],
                    child_name: [
                        {required: true, message: '请输入用户名', trigger: 'blur'}
                    ]
                },
                tableData: [],//表格数据

                decryptStr: '',

                itemValue: {},
                menus: [],
                defaultProps: {
                    children: 'children',
                    label: 'title'
                },
                defaultProps2: {
                  children: 'children',
                  label: 'district_name'
                }
            }
        },
        created (){
            this.detail = JSON.parse(localStorage.getItem('accountInfo'));
            this.account_type = localStorage.getItem('type');
            if (this.account_type ==4) {
                this.getTreeList();
            }
            this.initInfo();
        },
        methods: {
            initInfo() {
                this.$api.post(this.$apiUrl.childAccountList,{account_id: this.detail.account_id, commercial_id: this.detail.commercial_id},(res)=>{
                    this.tableData = res.data || [];
                },(res)=>{
                    this.$message.warning(res.message);
                })
            },
            addChild() {
                this.dialogFormVisible = true;
                this.form.child_account = '';
                this.form.child_name = '';
            },
            /** 获取子账号权限树 */
            getTreeList () {
                let params = {
                    school_id: this.detail.schoolIds, // 总对总学校id
                    account_id: this.detail.id, // 总对总账号id
                }
                this.$apiOuter.post(this.$apiUrl.commercialFulltree2, params,(res)=>{
                    if (res.message == "success" && res.result) {
                        this.menus = res.data;
                    } else {
                        this.$message.warning(res.message);
                        this.menus = [];
                    }
                },(res)=>{
                    this.$message.warning(res.message);
                },'public')
            },
            /** 获取子账号明细 */
            getCommercialTotalRuleInfo (id) {
                let params = {
                  account_id: id, // 总对总账号id
                }
                this.$api.post(this.$apiUrl.commercialTotalRuleInfo, params,(res)=>{
                    if (res.message == "success" && res.result) {
                        if (res.data && res.data[0] && res.data[0].schools) {
                            this.$refs.tree.setCheckedKeys(res.data[0].schools.split(','));
                        } else {
                            this.$refs.tree.setCheckedKeys([]);
                        }
                    } else {
                        this.$message.warning(res.message);
                        this.schoolList = [];
                    }
                },(res)=>{
                    this.$message.warning(res.message);
                    this.schoolList = [];
                })
            },
            /** 添加子账号 */
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$api.post(this.$apiUrl.addChildAccount,{...this.form,operator: this.detail.true_name, commercial_id: this.detail.commercial_id},(res)=>{
                            this.$message.success('添加成功');
                            this.initInfo();
                            this.dialogFormVisible = false;
                        },(res)=>{
                            this.$message.warning(res.message);
                        })
                    }
                })
            },
            /** 删除 */
            delChild(item) {
                this.$confirm('', '确定删除吗？', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$api.post(this.$apiUrl.delChildAccount,{operator: this.detail.true_name, account_id: item.id},(res)=>{
                        this.$message.success('删除成功');
                        this.initInfo();
                    },(res)=>{
                        this.$message.warning(res.message);
                    })
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消'
                    // });
                });
            },
            /** 授权 */
            addAuth(item) {
                this.dialogFormVisible1 = true;
                this.itemValue = item;
                if (this.account_type ==4) {
                    this.getCommercialTotalRuleInfo(item.id);
                } else {
                    this.menus = JSON.parse(localStorage.getItem('menus')).children;
                    this.$api.post(this.$apiUrl.childRuleInfo,{operator: this.detail.true_name, account_id: item.id},(res)=>{
                        if(res.data.rule_ids && res.data.rule_ids.length > 0){
                            this.$refs.tree.setCheckedKeys(res.data.rule_ids.split(','));
                        }else{
                            this.$refs.tree.setCheckedKeys([]);
                        }
                    },(res)=>{
                        this.$message.warning(res.message);
                    })
                }
            },
            submitAuth() {
                // console.log(this.$refs.tree.getCheckedKeys());
                let url, params;
                let checkedKeys = this.$refs.tree.getCheckedKeys();
                if(checkedKeys.length == 0){
                    this.$message.warning('请先授权');
                    return;
                }
                if (this.account_type ==4) {
                    url = this.$apiUrl.commercialTotalRule;
                    let schoolsIds = this.deepLoop([], this.menus, checkedKeys);
                    params = {
                        account_id: this.itemValue.id,
                        operator: localStorage.getItem('account'),
                        schools: checkedKeys.join(','),
                        school_list: schoolsIds.join(','),
                    }
                } else {
                    url = this.$apiUrl.dealChildRule;
                    let pid = JSON.parse(localStorage.getItem('menus')).rule_id;
                    params = {
                        operator: this.detail.true_name,
                        account_id: this.itemValue.id,
                        rule_ids: pid + ',' + checkedKeys.join(',')
                    }
                }
                this.$api.post(url,params,(res)=>{
                    this.$message.success('授权成功');
                    this.dialogFormVisible1 = false;
                    this.initInfo();
                },(res)=>{
                    this.$message.warning(res.message);
                })
            },
            resetPwd(item) {
                this.$api.post(this.$apiUrl.resetPwd,{operator: this.detail.true_name, account_id: item.id},(res)=>{
                    this.$message.success('重置成功');
                },(res)=>{
                    this.$message.warning(res.message);
                })
            },
            deepLoop(arr, list, keys) {
                list.forEach(item => {
                    if(!item.children) {
                        if (keys.indexOf(item.district_id) != -1) arr.push(item.district_id);
                    } else {
                        this.deepLoop(arr, item.children, keys);
                    }
                })
                return arr;
            }
        }
    }
</script>
<style lang="scss"  scoped>

</style>


// WEBPACK FOOTER //
// account.vue?0a525d90